var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapePpg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 244.07215978664135 89.97697922515499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-right-center-button-1",
    opacity: 1,
    fillRule: "evenodd",
    d: "M10.000000000001492,48.99999999999999 L1.3642420526593924e-12,60.00239520842755 L1.3642420526593924e-12,89.97697922515499 L1.3642420526593924e-12,84.97697922515499 L5.000000000001357,89.97697922515499 L244.07215978664271,89.97697922515499 L244.07215978664271,1.9999999999999998 L225.57215978664246,0 L145.57215978664144,48.99999999999999 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-2",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(0,187,255)",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(0,187,255)",
    stopOpacity: 0.1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-right-center-button-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapePpg);
export default __webpack_public_path__ + "static/media/shape-ppg.3cf52bcfe6e509f124a38cb03496073f.svg";
export { ForwardRef as ReactComponent };